import React, { Suspense, useState } from 'react';
import { clsx } from '@core/js/utils/classNames.util';
import { prop } from 'ramda';
import { useComponentTranslations } from '@core/js/hooks/component';
import { useAppSelector } from '@core/js/store/hooks';
import { Icon } from '@core/js/components/common/Icon';
import { Link } from '@core/js/components/common/Link';
import { Balance } from '@core/js/components/main/Balance';

import style from './AccountPanelDetails.scss';

export const AccountPanelDetails: React.FC = () => {
    const translate = useComponentTranslations();
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const dtagBonusHistoryPage = dynamicTags?.DTAG_BONUS_HISTORY_PAGE;
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const bonusHistoryPage = dtagBonusHistoryPage || '/bonus-history';

    return (
        <div className={style.accountPanelDetails}>
            <div className={style.headerDetails}>
                <div className={style.titleBalance} onClick={() => setIsOpen(prev => !prev)}>
                    <Icon
                        type={isOpen ? 'headerDetailsShow' : 'headerDetailsHide'}
                        className={`${style.icon} ${isOpen ? 'cms-header-details-icon-show' : 'cms-header-details-icon-hide'}`}
                    />
                    <span className={style.title}>
                        {translate('header.account-panel-details.bonus-balance.title')}
                    </span>
                </div>
                <span className={style.amount}>
                    <Suspense fallback="">
                        <Balance type="total_bonus_balance" />
                    </Suspense>
                </span>
            </div>

            <div className={clsx([style.bodyDetails, isOpen && style.open])}>
                <div className={style.bonusFunds}>
                    <span className={style.titleFunds}>
                        {translate('header.account-panel-details.funds.title')}
                    </span>
                    <span className={style.amountFunds}>
                         <Suspense fallback="">
                            <Balance type="bonus_balance" />
                        </Suspense>
                    </span>
                </div>
                <div className={style.bonusPending}>
                    <span className={style.titlePending}>
                        {translate('header.account-panel-details.pending.title')}
                    </span>
                    <span className={style.amountPending}>
                         <Suspense fallback="">
                            <Balance type="bonus_pending_winnings" />
                        </Suspense>
                    </span>
                </div>
            </div>

            <span className={style.bonusHistoryPage}>
                <Link href={bonusHistoryPage} className={style.pageLink}>
                    {translate('header.account-panel-details.history-page.title')}
                </Link>
            </span>
        </div>
    );
};
